import { DuplicateRequestPayloadShape } from '../contracts/duplicate-request-payload-shape.interface';
import { isPlainObject } from './is-plain-object';

const ID_KEY = 'id';
const IDS_KEY = 'ids';
const MONGO_ID_KEY = '_id';
const CAMEL_CASE_ID_SUFFIX = 'Id';
const CAMEL_CASE_IDS_SUFFIX = 'Ids';
const UPPER_CASE_ID_SUFFIX = 'ID';
const UPPER_CASE_IDS_SUFFIX = 'IDs';

function isIdentifierKey(key: string): boolean {
	const normalizedKey = key.toLowerCase();

	return (
		normalizedKey === ID_KEY ||
		normalizedKey === IDS_KEY ||
		normalizedKey === MONGO_ID_KEY ||
		key.endsWith(CAMEL_CASE_ID_SUFFIX) ||
		key.endsWith(CAMEL_CASE_IDS_SUFFIX) ||
		key.endsWith(UPPER_CASE_ID_SUFFIX) ||
		key.endsWith(UPPER_CASE_IDS_SUFFIX)
	);
}

function hasIdentifierValue(value: unknown): boolean {
	if (Array.isArray(value)) {
		return value.length > 0;
	}

	return value !== null && value !== undefined && value !== '';
}

export function extractPayloadShape(value: unknown): DuplicateRequestPayloadShape {
	if (value === null || value === undefined) {
		return {
			valueType: 'empty',
			keys: [],
			isEmpty: true,
			hasId: false,
		};
	}

	if (Array.isArray(value)) {
		return {
			valueType: 'array',
			keys: [],
			isEmpty: value.length === 0,
			hasId: false,
			itemCount: value.length,
		};
	}

	if (!isPlainObject(value)) {
		return {
			valueType: 'primitive',
			keys: [],
			isEmpty: false,
			hasId: false,
		};
	}

	const keys = Object.keys(value).sort();

	return {
		valueType: 'object',
		keys,
		isEmpty: keys.length === 0,
		hasId: keys.some(key => isIdentifierKey(key) && hasIdentifierValue(value[key])),
	};
}
